<template>
  <div v-if="isLoggedIn">
    <h4>DISABLED. PLEASE LOGOUT FIRST</h4>
  </div>
  <div v-else class="content">
    <div class="reset-wrapper">
      <div class="reset">
        <h3>Nurse Verification</h3>
        <form id="subaccountform" @submit.prevent="handleVerifyNurse">
          <div class="mb-2">
            <div class="row mb-2 gx-2">
              <div class="col-md-6 col-12 form-group form-floating mb-2 mb-lg-0">
                <select
                  id="accnttype"
                  class="form-control"
                  v-model="accountType"
                  required
                  disabled
                >
                  <option value="">Select account type</option>
                  <option value="Manager">Manager</option>
                  <option value="Licensed Practical Nurse">
                    Licensed Practical Nurse
                  </option>
                  <option value="Registered Nurse">Registered Nurse</option>
                  <option value="Provider">Provider</option>
                </select>
                <label for="AccntRole" class="profile_label">Account Type:</label>
              </div>
              <div class="col-md-6 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="text"
                  name="accountexternid"
                  id="Accntexternid"
                  class="form-control"
                  disabled
                  v-model="form.externid"
                />
                <label for="AccntId" class="profile_label">ID #:</label>
              </div>
            </div>
            <div class="row mb-2 gx-2">
              <div class="col-md-4 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="text"
                  name="firstname"
                  id="AccntFname"
                  required
                  class="form-control"
                  placeholder="Required"
                  v-model="form.first"
                />
                <label for="AccntFname" class="profile_label">First Name:</label>
                <!-- <form-error
                  v-if="formErrors.first.length != 0"
                  :errors="formErrors.first"
                /> -->
              </div>
              <div class="col-md-4 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="text"
                  name="lastname"
                  id="AccntLname"
                  class="form-control"
                  placeholder="Required"
                  required
                  v-model="form.last"
                />
                <label for="AccntLname" class="profile_label">Last Name:</label>
                <!-- <form-error
                  v-if="formErrors.last.length != 0"
                  :errors="formErrors.last"
                /> -->
              </div>
              <div class="col-md-4 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="text"
                  name="accountUname"
                  id="AccntpUsername"
                  class="form-control"
                  placeholder="Required"
                  required
                  v-model="form.login"
                  disabled
                />
                <label for="AccntUsername" class="profile_label">Username:</label>
              </div>
            </div>
            <div class="row mb-2 gx-2">
              <div class="col-md-6 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="password"
                  name="accountPw"
                  id="AccntPw"
                  required
                  placeholder="Enter password"
                  class="form-control"
                  v-model="form.password"
                  @change="validatePassword"
                />
                <label for="AccntPw" class="profile_label">Password:</label>
                <form-error :errors="formErrors.password" />
              </div>
              <div class="col-md-6 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="password"
                  name="accountPwConfirm"
                  id="AccntPwConfirm"
                  required
                  placeholder="Confirm password"
                  class="form-control"
                  v-model="form.password2"
                  @change="confirmPassword"
                />
                <label for="AccntPwConfirm" class="profile_label"
                  >Confirm Password:</label
                >
                <form-error :errors="formErrors.password2" />
              </div>
            </div>
            <div class="row mb-2 gx-2">
              <div class="col-md-6 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="email"
                  name="accountEmail"
                  id="AccntEmail"
                  required
                  placeholder="Required"
                  class="form-control"
                  v-model="form.email"
                  disabled
                />
                <label for="AccntEmail" class="profile_label">Account Email:</label>
              </div>
              <!-- <div class="col-md-2 col-12 form-group form-floating mb-2 mb-lg-0">
                <select
                  v-model="form.primaryPhoneType"
                  class="col-12 form-select"
                  required
                >
                  <option v-for="phone in phoneTypes" :key="phone.id" :value="phone.id">
                    {{ phone.type }}
                  </option>
                </select>
                <label class="profile_label">Phone type</label>
              </div> -->
              <div class="col-md-6 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="text"
                  id="regphone"
                  class="form-control"
                  v-model="form.cell"
                  placeholder="Required"
                />
                <label for="mblphone" class="profile_label">Phone Number</label>
              </div>
            </div>
            <div class="row mb-2 gx-2">
              <div class="col-md-5 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="text"
                  name="personalAddress"
                  id="AccntAddress"
                  class="form-control"
                  placeholder="Required"
                  v-model="form.addr"
                />
                <label for="AccntAddress" class="profile_label">Address:</label>
              </div>
              <div class="col-md-3 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  v-model="form.city"
                  type="text"
                  name="personalcity"
                  id="AccntCity"
                  class="form-control"
                  placeholder="Required"
                />
                <label for="AccntCity" class="profile_label">City:</label>
              </div>
              <div class="col-md-2 col-12 form-group form-floating mb-2 mb-lg-0">
                <select
                  v-model="form.state"
                  name="personalstate"
                  id="AccntState"
                  class="form-select"
                >
                  <option value="">Select a state</option>
                  <option
                    v-for="(state, index) in states"
                    :key="index"
                    :value="state.abbr"
                  >
                    {{ state.abbr }}
                  </option>
                </select>
                <label for="AccntState" class="profile_label">State:</label>
              </div>
              <div class="col-md-2 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  v-model="form.zip"
                  type="text"
                  name="personalzip"
                  id="AccntZip"
                  class="form-control"
                  placeholder="Required"
                />
                <label for="AccntZip" class="profile_label">Zip:</label>
              </div>
            </div>
            <!-- <div class="col-sm-12 col-md-12 col-lg-12 npi-container"> -->
            <!-- <div class="col-sm-12 col-md-12 col-lg-12 npi-license">
                <label for="Npiproflicense">NPI:</label>
                <input
                  v-model="form.npi"
                  type="text"
                  name="Npipersonalicense"
                  id="AccntNpilicense"
                />
              </div> -->
            <!--- <div class="col-sm-12 col-md-6 col-lg-6">
                        <label for="NpiAccntdob">Date of Birth:</label><br>
                        <input type="date" name="Npiaccntdob" id="NpiAccntdobd" placeholder="Date of Birth"/>
                    </div>-->
            <!--<div class="col-sm-12 col-md-6 col-lg-6">
                        <label for="NpiAccntSS">last 4 Social Number:</label><br>
                        <input type="text" name="NpiaccountSS" id="NpiAccntSS" placeholder="Last 4 Social Security #"/>
                    </div>-->
            <!-- </div> -->
            <!-- <div class="col-sm-12 col-md-6 col-lg-6">
                        <label for="AccntSS">last 4 Social Number:</label><br>
                        <input type="text" name="accountSS" id="AccntSS" placeholder="Last 4 Social Security #"/>
                    </div>-->
            <div class="row mb-2 gx-2">
              <!-- <div class="col-md-2 col-12 form-group form-floating mb-2 mb-lg-0">
                <select
                  v-model="form.gender"
                  name="accountGender"
                  id="AccntGender"
                  required
                  class="form-select"
                >
                  <option value="">Please select</option>
                  <option value="1">Male</option>
                  <option value="2">Female</option>
                </select>
                <label for="AccntGender" class="profile_label">Gender:</label>
              </div> -->
              <!-- <div class="col-md-4 col-12 form-group form-floating mb-2 mb-lg-0">
                <select id="AccntPref" class="form-select" v-model="form.pref">
                  <option value="Email" selected="selected">Email</option>
                  <option value="SMS">SMS</option>
                  <option value="Phone">Phone</option>
                  <option value="All">SMS, Phone & Email</option>
                </select>
                <label for="AccntPref" class="profile_label"
                  >Communication Preference:</label
                >
              </div> -->
              <div class="col-md-4 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  class="form-control"
                  type="text"
                  name="personalicense"
                  id="Accntproflicense"
                  v-model="form.license"
                />
                <label for="Accntproflicense" class="profile_label"
                  >Professional License:</label
                >
              </div>
              <div class="col-md-2 col-12 form-group form-floating mb-2 mb-lg-0">
                <select
                  v-model="form.licenseSt"
                  name="licensestate"
                  id="LicenseState"
                  class="form-select"
                >
                  <option value="">Select a state</option>
                  <option
                    v-for="(state, index) in states"
                    :key="index"
                    :value="state.abbr"
                  >
                    {{ state.abbr }}
                  </option>
                </select>
                <label for="AccntState" class="profile_label">License State:</label>
              </div>
              <div class="col-md-2 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  id="dob"
                  v-model="form.dob"
                  class="form-control"
                  required
                  type="date"
                />
                <label for="dob" class="profile_label">DOB:</label>
              </div>
              <div class="col-md-2 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  id="ssn"
                  v-model="form.ssn"
                  class="form-control col-md-6"
                  type="text"
                />
                <label for="SSN" class="profile_label">SSN (last four):</label>
              </div>
            </div>
            <div class="row mb-2 gx-2">
              <div class="accountform-btn">
                <input
                  type="submit"
                  class="btn btn-primary"
                  value="Submit & Verify"
                  id="sbmtuserbtn"
                />
                <button class="return__link btn btn-primary"><router-link to="/login" class="form__link">Return to log in</router-link></button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import { mask } from "vue-the-mask";
import { CURR_API, OTHER_API } from "@/constants/apis";
import { finalizeRegistration, updatePassword } from "@/api/userApi";
import FormError from "@/components/public-layouts/register/FormError";
import axios from "axios";
import us from "us";
import router from "@/router/index";
import { LoginNavigation } from "@/store/modules/fsm/messages";
import VALIDATION_ERRORS from "@/data/validationErrors";
export default {
  name: "verify-nurse-page",
  components: {
    "form-error": FormError,
  },
  directives: {
    mask,
  },
  data() {
    return {
      states: us.states,
      form: {
        externid: "",
        first: "",
        last: "",
        login: "",
        password: "",
        password2: "",
        enrollmentId: null,
        dob: null,
        email: "",
        addr: "",
        city: "",
        state: "",
        zip: null,
        cell: null,
        ssn: "",
        license: "",
        licenseSt: "",
      },
      nurseType: null,
      formErrors: {},
    };
  },
  props: {
    accountType: "",
    unique: "",
    accntnum: "",
  },
  computed: {
    isLoggedIn: function () {
      let isLoggedIn = store.getters["login/isLoggedIn"];
      return isLoggedIn;
    },
  },
  beforeCreate() {
    if (this.isLoggedIn) {
      alert("Please logout to verify account");
      router.push({ name: LoginNavigation });
    }
    let isInit = this.$gotInitialMessage();
    if (!isInit) {
      let href = location.href + "";
      setTimeout(() => location.assign(href), 5000);
    }
  },
  created() {
    for (let key in this.form) {
      this.$set(this.formErrors, key, []);
    }
  },
  async mounted() {
    this.webHook({
      Account: {
        API_Meth: "GetPendingAccountInfo",
        accountype: this.accountType,
        uniqueNine: this.unique,
      },
    }).then((res) => {
      if (res.data.status === "No Records Found") {
        router.push({ name: LoginNavigation });
        alert("There is an error with this verification link. Please request a new one.");
        return;
      } else {
        let dbData = res.data.data[0];
        if (dbData.account_status != "Pending") {
          router.push({ name: LoginNavigation });
          alert("This account has already been verified.");
          return;
        }
        this.form.externid = dbData.unique_ID;
        this.form.login = dbData.username;
        this.form.first = dbData.user_Fname;
        this.form.last = dbData.user_Lname;
        this.form.email = dbData.user_email;
        this.form.addr = dbData.address;
        this.form.city = dbData.city;
        this.form.state = dbData.state;
        this.form.zip = dbData.zip;
        this.form.cell = dbData.user_phone;
        this.form.license = dbData.proffesionalLicense;
        this.nurseType = dbData.account_type;
      }
    });
  },
  methods: {
    validate() {
      for (let key in this.formErrors) {
        if (this.formErrors[key] && this.formErrors[key].length > 0) {
          return false;
        }
      }
      return true;
    },
    validatePassword() {
      const strongRegex = new RegExp(
        `^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[~!@#\$%\^&\*\(\)\-\+,\.\?\/;:\'\"\[\]\{\}\|\\])(?=.{12,})`
      );
      const mediumRegex = new RegExp(
        "^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{8,})"
      );

      //FIXME: use a better regex
      const passwordRegex = new RegExp(`^[a-zA-Z0-9,\.\?~!@#\$%\^&\*_]+$`);

      let error = null;
      this.formErrors.password = [];

      if (!passwordRegex.test(this.form.password)) {
        error = VALIDATION_ERRORS.PASSWORD_CHARACTERS;
        this.$set(this.formErrors.password, this.formErrors.password.length, error);
      }
      if (!(this.form.password.length >= 12 && this.form.password.length <= 24)) {
        error = VALIDATION_ERRORS.PASSWORD_LENGTH;
        this.$set(this.formErrors.password, this.formErrors.password.length, error);
      }

      if (this.form.password2 && this.form.password2 !== "") {
        this.confirmPassword();
      }
    },
    confirmPassword() {
      this.formErrors.password2 = [];
      if (this.form.password !== this.form.password2) {
        this.formErrors.password2.push(VALIDATION_ERRORS.PASSWORD_MISMATCH);
      }
    },
    async handleVerifyNurse() {
      if (!this.validate()) {
        this.$swal({
          type: "warning",
          title: "Error",
          text: "Please fix the errors in the form to finish registering this account.",
        });
        return;
      }
      let loader = null;
      loader = this.$loading.show(
        {
          container: this.$refs.pageBody,
        },
        {
          after: this.$createElement("div", {}, [
            `Verifying license and updating profile...`,
          ]),
        }
      );
      this.startLookup({
        rnlicense: this.form.license,
        jurisdiction: this.form.licenseSt,
        ltype: this.nurseType == "Licensed Practical Nurse" ? "LPN" : "RN",
      }).then((res) => {
        if (!res.data.status) {
          let resState = res.data.find(
            (d) => d.JurisdictionAbbreviation == this.form.licenseSt
          );
          if (!resState) {
            loader.hide();
            this.$swal({
              type: "warning",
              title: "Error",
              text:
                "The license state cannot be verified. Please make sure the information is correct.",
            });
            return;
          } else {
            let encumberStatus = resState.LicenseStatus.toUpperCase();
            if (encumberStatus === "ENCUMBERED" || encumberStatus === "EXPIRED" || encumberStatus === "SUSPENSION" || encumberStatus === "SUSPENSION (SEE HISTORY)") {
              loader.hide();
              this.$swal({
                type: "error",
                title: "Error",
                text: `This license number in the state of '${
                  this.form.licenseSt
                }' is '${encumberStatus.toLowerCase()}'. The account cannot be verified.`,
              });
              return;
            } else {
              finalizeRegistration(this.form.externid).then((res) => {
                updatePassword({
                  email: this.form.email,
                  newPassword: this.form.password,
                })
                  .then((res2) => {
                    loader.hide();
                    this.$swal({
                      type: "success",
                      title: "Success!",
                      text:
                        "Your account has been verified successfully and activated. You will now be redirected to our login screen.",
                    });
                  })
                  .then((result) => {
                    router.push({ name: LoginNavigation });
                    this.startInternalAdd({
                      accountnumber: this.accntnum,
                      extern: this.form.externid,
                      firstname: this.form.first,
                      lastname: this.form.last,
                      licensnum: this.form.license,
                      ltype: this.form.licenseSt,
                      email: this.form.email,
                      primephone: this.form.cell,
                      address1: this.form.addr,
                      city: this.form.city,
                      state: this.form.state,
                      zip: this.form.zip,
                    }).then((result2) => {
                      if (result2.data.message != "Inserted") console.log(result2);
                    });
                  });
              });
            }
          }
        } else {
          this.startAdd({
            jurisdiction: this.form.licenseSt,
            state: this.form.licenseSt,
            licensnum: this.form.license,
            bdayear: this.form.dob.substring(0, 4),
            lastfourssn: this.form.ssn,
            ltype: this.nurseType == "Licensed Practical Nurse" ? "LPN" : "RN",
          }).then((res2) => {
            if (res2.data.status === "Nurse Added") {
              this.startLookup({
                rnlicense: this.form.license,
                jurisdiction: this.form.licenseSt,
                ltype: this.nurseType == "Licensed Practical Nurse" ? "LPN" : "RN",
              }).then((res3) => {
                let resState2 = res3.data.find(
                  (d) => d.JurisdictionAbbreviation == this.form.licenseSt
                );
                if (!resState2) {
                  loader.hide();
                  this.$swal({
                    type: "warning",
                    title: "Error",
                    text:
                      "The license state cannot be verified. Please make sure the information is correct.",
                  });
                  return;
                } else {
                  let encumberStatus2 = resState2.LicenseStatus.toUpperCase();
                  if (encumberStatus2 === "ENCUMBERED" || encumberStatus2 === "EXPIRED" || encumberStatus === "SUSPENSION" || encumberStatus === "SUSPENSION (SEE HISTORY)") {
                    loader.hide();
                    this.$swal({
                      type: "error",
                      title: "Error",
                      text: `This license number in the state of '${
                        this.form.licenseSt
                      }' is '${encumberStatus2.toLowerCase()}'. The account cannot be verified.`,
                    });
                    return;
                  } else {
                    finalizeRegistration(this.form.externid).then((res) => {
                      updatePassword({
                        email: this.form.email,
                        newPassword: this.form.password,
                      }).then((res2) => {
                        console.log(res2);
                        loader.hide();
                        this.$swal({
                          type: "success",
                          title: "Success!",
                          text:
                            "Your account has been verified successfully and activated. You will now be redirected to our login screen.",
                        }).then((result) => {
                          router.push({ name: LoginNavigation });
                          this.startInternalAdd({
                            accountnumber: this.accntnum,
                            externid: this.form.externid,
                            firstname: this.form.first,
                            lastname: this.form.last,
                            licensnum: this.form.license,
                            ltype: this.form.licenseSt,
                            email: this.form.email,
                            primephone: this.form.cell,
                            address1: this.form.addr,
                            city: this.form.city,
                            state: this.form.state,
                            zip: this.form.zip,
                          }).then((result2) => {
                            if (result2.data.message != "Inserted") console.log(result2);
                          });
                        });
                      });
                    });
                  }
                }
              });
            } else {
              loader.hide();
              this.$swal({
                type: "warning",
                title: "Error",
                text:
                  "The license state cannot be verified. Please make sure the information is correct, particularly your date of birth and the last 4 of your SSN.",
              });
              return;
            }
          });
        }
      });
    },
    async webHook(request) {
      return await axios.post(CURR_API + "/tswebhook.php", request, {
        headers: { "Content-Type": "application/json;" },
      });
    },
    async startInternalAdd(request) {
      return this.webHook({
        ManageNurseList: {
          API_Meth: "InternalAddNurse",
          hospitalpracsetting: "",
          notficationenabled: "N",
          reminderenabled: "N",
          locationlist: "",
          activestatus: "YES",
          secondaryphone: "",
          bdayear: "1970-01-01",
          lastfourssn: "",
          address2: "",
          ...request,
        },
      });
    },
    async startLookup(request) {
      return this.webHook({
        NursyInfo: {
          API_Meth: "LookupNursesInfo",
          ...request,
        },
      });
    },
    async startAdd(request) {
      return this.webHook({
        ManageNurseList: {
          API_Meth: "Add_Nurse",
          ncsid: "",
          subactioncode: "A",
          address1: "Manhattan",
          address2: "",
          city: "New York",
          zip: "10001",
          hospitalpracsetting: "8",
          hostpracsettingother: "",
          notficationenabled: "N",
          reminderenabled: "N",
          locationlist: "",
          recid: "",
          ...request,
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../stylesheets/mixins/alignment";
$color-base: #0060ff;
.btn--login {
  color: #fff;
  background-color: $color-base;

  &:hover {
    background-color: lighten($color-base, 5%);
  }
}
.return__link {
  float: right;
  background-color: $color-base;
}
.form__link {
  color: white;
  text-decoration: none;
}
#sbmtuserbtn {
  border-radius: 0.375em;
}
.button-group {
  /*margin-top: 1.5rem;*/

  .form__link {
    color: $color-base;
    font-size: 0.85rem;
    margin-top: 0.5rem;
    display: block;

    &:hover {
      text-decoration: underline;
    }
  }
}
.content {
  width: 100%;
  height: auto;
  background: url("../../assets/images/bg.jpg") no-repeat center fixed; // TODO image subject to copyright
  background-size: cover;
  position: relative;
}
.reset-wrapper {
  height: 100vh;
  width: 100%;
  position: relative;
}

.reset {
  width: 60% !important;
  background-color: #fff;
  padding: 2rem;
  -moz-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12),
    0 1px 5px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12),
    0 1px 5px 0 rgba(0, 0, 0, 0.2);

  @include absoluteCenter(380px);
}
.reset__introduction {
  color: darken(gray, 10%);
  font-size: 14px;
  text-align: center;
}
.btn--reset {
  color: #fff;
  background-color: $color-base;
  &:hover {
    background-color: lighten($color-base, 5%);
  }
}

.button-group {
  margin-top: 1.5rem;

  .form__link {
    color: $color-base;
    font-size: 0.85rem;
    margin-top: 0.5rem;
    display: block;

    &:hover {
      text-decoration: underline;
    }
  }
}

.form__input {
  font-size: 0.85rem;
}
.col-form-label {
  font-size: 14px;
  width: 100%;
}

@media only screen and (max-width: 768px) {
  .reset {
    width: 90% !important;
    height: 90%;
    overflow: auto;
  }
}
</style>
